import networkTS from './networkTS'
import { TicketServiceDeleteInvoicePayload } from '@/types/api'

export default {
  async isDeepOEnabled(accountId: string) {
    return networkTS.deepoServiceHasDeepoEnabled({ accountId: accountId })
      .then(response => {
        return response.data
      })
  },
  async getPartnerAccessUrl(accountId: string) {
    return networkTS.deepoServiceGetPartnerAccessUrl({ accountId: accountId })
      .then(response => {
        return response.data
      })
  },
  async getFileTransmissionsByReferenceId(referenceId: string) {
    return networkTS.deepoServiceGetFileTransmissionsByReferenceId(referenceId)
      .then(response => {
        return response.data
      })
  },
  async sendFile(mediaId: string, referenceIds: string[]) {
    return networkTS.deepoServiceSendFile({ mediaId: mediaId, referenceIds: referenceIds })
      .then(response => {
        return response.data
      })
  },
  async analyseNodeStatus(fileTransmissionId: string) {
    return networkTS.deepoServiceAnalyseNodeStatus(fileTransmissionId)
      .then(response => {
        return response.data
      })
  },
  async deleteInvoice(id: string, body: TicketServiceDeleteInvoicePayload) {
    return networkTS.ticketServiceDeleteInvoice(id, body)
      .then(response => {
        return response.data
      })
  }
}
